import { render, staticRenderFns } from "./DialogEditItem.vue?vue&type=template&id=2370beb9&"
import script from "./DialogEditItem.vue?vue&type=script&lang=js&"
export * from "./DialogEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports